module.exports = "/img/42.6c34cf.webp";